export default [
  {
    name: "sahil kanerkar",
    ServiceRequired: "Care Taker",
    description: "Care Taker",
    createDate: "26 / 06 / 2022",
    time: "1:30",
    sessiontype: "online",
    status: "accept",
  },
  {
    name: "Sumit Jaiswal",
    ServiceRequired: "Care Taker",
    description: "Care Taker",
    createDate: "11 / 01 / 2022",
    time: "1:30",
    sessiontype: "online",
    status: "accept",
  },
  {
    name: "Yash Singh",
    ServiceRequired: "Care Taker",
    description: "Care Taker",
    createDate: "15 / 06 / 2022",
    time: "1:30",
    sessiontype: "online",
    status: "accept",
  },
];
